import React, { FC, useContext } from 'react';

import { Toggle } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

export const TransplantHalls: FC = () => {
  const { t } = useContext(LocalizationContext);

  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);

  return (
    <Toggle
      label={t('settings.shell.change.title')}
      description={t('settings.shell.change.description')}
      value={settings.hostGroupSwitch}
      onChange={(value: string) => {
        setSetting({
          alias: ESettingsAliases.SHELL_HOST_GROUP_SWITCH,
          value: value ? '1' : '0',
        });
      }}
      variant="secondary"
      emptyBg
    />
  );
};
